<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <!-- Section: Intro Text -->
  <div class="intro-section">
    <h2>Notre équipe de spécialistes vous aide <span class="highlight-purple">à toutes les étapes</span></h2>
    <p>de la vie de votre contrat d'assurance.</p>
  </div>

  <!-- Approche Cards Grid -->
  <div class="approche-grid">
    
    <!-- Card 1: Parfaite compréhension -->
    <div class="approche-card">
      <div class="card-icon">
        <i class="pi pi-search"></i>
      </div>
      <div class="card-content">
        <h3>Parfaite compréhension de votre situation actuelle</h3>
        <p>
          Brokins est spécialisé dans l'aide des particuliers, des professionnels et entreprises 
          à s'assurer correctement en prenant le temps de comprendre votre situation et vos objectifs. 
          Que vous ayez des difficultés à trouver une assurance, ou que vous ne sachiez 
          pas de quoi vous avez besoin comme couverture, notre équipe est là pour vous 
          guider.
        </p>
      </div>
    </div>

    <!-- Card 2: Interrogation de plusieurs assureurs -->
    <div class="approche-card">
      <div class="card-icon">
        <i class="pi pi-users"></i>
      </div>
      <div class="card-content">
        <h3>Interrogation de plusieurs assureurs à votre place</h3>
        <p>
          Cette formalité administrative obligatoire prend beaucoup de temps, n'est pas 
          intéressante et est complexe à comprendre car les contrats sont tous différents 
          et n'assurent pas de la même manière. Ainsi, nous cherchons la meilleure solution 
          sur le marché et revenons avec le TOP 3 des solutions.
        </p>
      </div>
    </div>

    <!-- Card 3: Négociation & choix -->
    <div class="approche-card">
      <div class="card-icon">
        <i class="pi pi-comments"></i>
      </div>
      <div class="card-content">
        <h3>Négociation & choix du meilleur contrat</h3>
        <p>
          Grâce à un nombre de partenaires assureurs importants, mais aussi grâce à 
          une relation serrée avec ces derniers (via des protocoles d'accord) nous sommes 
          en mesure de trouver le contrat d'assurance Professionnel, le contrat d'assurance 
          Entreprise ou particulier au meilleur rapport qualité/prix.
        </p>
      </div>
    </div>

    <!-- Card 4: Suivi de vos problèmes -->
    <div class="approche-card">
      <div class="card-icon">
        <i class="pi pi-shield"></i>
      </div>
      <div class="card-content">
        <h3>Suivi de vos problèmes & sinistres jusqu'à la fin</h3>
        <p>
          Nous fournissons un suivi de votre dossier durant toute la vie du contrat et surtout 
          pendant les moments difficiles comme les sinistres, les résiliations, les accidents 
          de paiements.
        </p>
      </div>
    </div>

  </div>

  <!-- Bouton En savoir plus centralisé -->
  <div class="savoir-plus-section">
    <button class="btn-savoir-plus" (click)="toggleDetailedContent()" 
            [class.expanded]="showDetailedContent">
      En savoir plus
    </button>
  </div>

  <!-- Contenu détaillé complet -->
  <div class="detailed-content" *ngIf="showDetailedContent">
    <div class="content-wrapper">
      <p>
        Contrairement à ce que l'on peut penser, un courtier ne vend pas directement de contrats d'assurance 
        à ses clients, le courtier étant un intermédiaire, il aide ses clients à en acheter, contrairement 
        à l'Agent d'assurance qui lui, représente uniquement son assureur via un mandat. En cela, le cabinet 
        <strong>BROKINS</strong> (<a href="http://www.brokins.fr" target="_blank" class="link-purple">www.brokins.fr</a>), 
        par le biais de son équipe d'experts-conseils aux clients et sa connaissance approfondie du marché de 
        l'assurance, propose les meilleures solutions existantes sur le marché français de l'assurance assurance.
      </p>

      <h3>Le courtage en assurances</h3>
      <p>
        Brokins trouve l'assureur qui correspond le plus à vos besoins : Le courtage en assurance est une 
        activité commerciale indépendante qui consiste à mettre en relation un client (l'assuré) avec un 
        assureur. Brokins est un cabinet généraliste, avec des équipes spécialisées par produit. Notre Cabinet 
        de courtage en Assurances agit en tant que mandataire de son client ; à ce titre, il mettra en œuvre 
        son expertise et sa connaissance du marché pour identifier des risques spécifiques à couvrir et trouver 
        l'offre la plus adaptée et la plus avantageuse pour son client. Brokins devient votre conseiller personnel 
        en matière d'assurance. Mais surtout, il est libre de faire des objectifs de recommandations. Sa première 
        et unique responsabilité est de servir vos intérêts en premier.
      </p>

      <h3>Le courtier en assurances Brokins vous permet d'économiser du temps et de l'argent</h3>
      <p>
        Passer par Brokins permet donc aux clients souhaitant souscrire un contrat d'assurance de bénéficier 
        d'un gain de temps et d'argent non négligeable que ce soit au moment de choisir un contrat d'assurance 
        ou du suivi de celui-ci, grâce au paiement et à la signature de son contrat en ligne. Fini la paperasse ! 
        Le futur assuré peut se voir ainsi proposer, selon la prestation recherchée, un conseil, un devis gratuit 
        ou une simulation comparative et gagner un temps considérable.
      </p>
      <p>
        Utiliser les services d'un courtier comme Brokins ne vous occasionne aucun frais supplémentaire. Un courtier 
        reçoit une commission de toute compagnie d'assurance auprès de laquelle il place un contrat ; il n'a aucun 
        incitatif financier pour choisir une compagnie plutôt qu'une autre. De plus, il fait preuve de transparence 
        absolue en ce qui concerne ses opérations et il vous encourage à lui poser des questions sur sa rémunération.
      </p>
      <p>
        Enfin, le montant de la prime à payer par le client, pour un même produit vendu en direct par un assureur, 
        est moins élevé chez les courtiers et notamment chez Brokins. En effet, grâce à l'intelligence de notre 
        plateforme (qui est une traduction informatique embarquée de la formation professionnelle, de l'expertise 
        assurance, et du conseil des meilleurs courtiers), nous vous proposons un contrat le plus proche de votre 
        besoin, ce qui limite automatiquement les risques de l'assureur du contrat.
      </p>

      <h3>Le courtier en assurances Brokins vous permet d'avoir une offre cohérente entre ses différentes assurances</h3>
      <p>
        Brokins, en tant que courtier complètement indépendant, identifie rapidement les offres disponibles sur le 
        marché en adéquation avec les besoins du client et optimise ses chances de trouver une meilleure assurance 
        parmi les 4 grandes familles de risques auxquels sont exposées les entreprises :
      </p>
      <ul>
        <li><strong>Les risques de dommages aux biens</strong> : locaux, matériels, mobiliers, marchandises,</li>
        <li><strong>Les risques de responsabilité</strong> : responsabilités encourues vis-à-vis des tiers du fait 
            de votre exploitation (un client se blesse dans votre local, à cause d'une anomalie de votre matériel), 
            responsabilités encourues du fait des produits (ou des prestations) vendu, diffusé ou distribué (un client 
            n'est pas contenu du résultat de votre travail),</li>
        <li><strong>Les risques financiers</strong> : perte d'exploitation, perte de valeur vénale du fonds de commerce, 
            risque de perte de créance sur les clients,</li>
        <li><strong>Les risques de personnes</strong> : dommages matériels ou corporels subis par votre personnel dans 
            vos locaux, risques encourus par votre personnel en dehors de vos locaux ou risques encourus par vos 
            collaborateurs en mission à l'étranger.</li>
      </ul>
      <p class="highlight-box">
        <strong>⇒</strong> Le site web <a href="http://www.brokins.fr" target="_blank" class="link-purple">www.brokins.fr</a>, 
        en tant que courtier en assurance a le recul et les connaissances nécessaires pour faire en sorte que les différentes 
        assurances auxquelles vous souscrivez ne se recoupent pas.
      </p>

      <h3>Le courtier en assurances Brokins propose de nombreux services à ses clients</h3>
      <p>
        Un assuré a différents besoins, comme par exemple gérer ses contrats en ligne. Il peut également formuler des 
        propositions à son client quand il identifie des offres plus avantageuses sur le marché ou lui fournir une aide 
        à la résiliation. Il propose également d'envoyer régulièrement des informations spécifiques, liées à son domaine 
        d'activité, mais aussi générales comme les évolutions réglementaires l'impactant. Enfin, le courtier Brokins 
        enverra à ses clients différents conseils simples liés à la gestion de leurs risques. Par exemple le fait :
      </p>
      <ul>
        <li>de prendre des mesures de prévention,</li>
        <li>d'observer des mesures de sécurité,</li>
        <li>d'avoir éventuellement à changer ses habitudes,</li>
        <li>de prendre en charge une partie des risques (rétention).</li>
      </ul>
      <p class="highlight-box">
        <strong>⇒</strong> Et tout ça, gratuitement. En effet, quand la collaboration aboutit à la souscription d'un contrat 
        d'assurance, le client ne devra verser aucune somme à Brokins SAS. La compagnie d'assurance nous versera une commission 
        qui se répercutera sur le montant de la prime d'assurance.
      </p>

      <h3>Brokins défend les intérêts du client après la souscription du contrat</h3>
      <p>
        Le travail du courtier en assurance Brokins ne s'arrête pas à la signature du contrat. Il se charge également du suivi 
        via l'espace client en ligne de l'assuré, et s'assure du respect de ses clauses. En cas de sinistre, le courtier Brokins 
        prend en charge les démarches de déclaration de sinistre auprès de la compagnie d'assurance via votre propre déclaration 
        sur l'espace client, mais également de défendre son client en cas de litige avec la compagnie en vous mettant en place en 
        contact avec un avocat spécialisé dans les litiges avec les assureurs. Passer par Brokins permet ici encore au client de 
        gagner un temps précieux et d'augmenter ses chances d'obtenir une indemnisation.
      </p>
    </div>
  </div>

</app-page-layout>
